import { Container } from '@hivebrite/design-system/Container';
import { useBreakpoint } from '@hivebrite/design-system/Theme';

import Grid, { Col, Row } from 'hb-react/shared/components/DesignSystem/Grid';

const PublicationLayout = ({
  children,
  pb = '120px',
}: {
  children: React.ReactNode;
  pb?: string;
}) => {
  const breakpoint = useBreakpoint();

  return (
    <Container height="auto" pb={pb}>
      <Grid width="100%" height="100%" mx={breakpoint === 's' ? 0 : undefined}>
        <Row>
          <Col
            width={({ numCols }) => ({
              xl: 8 / Number(numCols),
              m: 10 / Number(numCols),
            })}
            offset={({ numCols }) => ({
              xl: 2 / Number(numCols),
              m: 1 / Number(numCols),
            })}
            pt={{ _: 0, m: 6 }}
          >
            {children}
          </Col>
        </Row>
      </Grid>
    </Container>
  );
};

export default PublicationLayout;
